<template>
    <div class="col-6">
        <div class="content-tabs text-center border border-bottom-0 border-gray-500">
            <div
                v-for="tab in tabs"
                class="d-inline-block w-50 content-tabs-item"
                v-bind:class="{active: isSelected(tab)}"
                @click="onTabSelect(tab)"
            >
                <div class="pt-2 pb-2">
                    <h5 class="mb-0" v-text="tab.title"></h5>
                </div>
            </div>
        </div>
        <div
            class="border border-top-0 border-gray-500"
        >
            <component
                class="p-2"
                v-if="hasSendListSelected"
                v-bind:is="activeComponent"
                :send-list="sendList"
                :key="componentKey"
            ></component>
        </div>
    </div>
</template>

<script>
  import ConversationList from './conversation-list';
  import CommonBulkMessageList from './common-bulk-message-list/common-bulk-message-list';
  // import ScheduleBulkMessageList from './schedule-bulk-message-list';

  export default {
    components: {
      'conversation-list': ConversationList,
      'common-bulk-message-list': CommonBulkMessageList,
      // 'schedule-bulk-message-list': ScheduleBulkMessageList,
    },

    props: {
      margin: {
        type: Number,
        default: 0,
      }
    },

    data() {
      return {
        tabs: [
          {name: 'conversations', title: 'CONVERSATIONS', component: 'conversation-list'},
          {name: 'messages', title: 'MESSAGES', component: 'common-bulk-message-list'},
          // {name: 'schedule-messages', title: 'SCHEDULE MESSAGES', component: 'schedule-bulk-message-list'},
        ],
        active: null,
        sendList: null,
      };
    },

    computed: {
      /**
       * @return {number|null}
       */
      componentKey() {
        return _.get(this.sendList, 'id', null);
      },

      /**
       * @return {string|null}
       */
      activeComponent() {
        return _.get(this.active, 'component', null);
      },

      /**
       * @return {boolean}
       */
      hasSendListSelected() {
        return Boolean(this.sendList);
      },
    },

    methods: {
      /**
       * @param {string} name
       * @return {Object|null}
       */
      tabByName(name) {
        return _.find(this.tabs, {name: name}) || null;
      },

      /**
       * @param {Object} item
       */
      onTabSelect(item) {
        this.active = item;
      },

      /**
        * @param {Object} item
       * @return {boolean}
       */
      isSelected(item) {
        if (item) {
          return item.name === _.get(this.active, 'name');
        }
      },

      /**
       * @param {Object|null} item
       */
      onSendListSelect(item) {
        this.sendList = item;
      },
    },

    mounted() {
      this.active = this.tabByName('conversations');
    },

    created() {
      eventBus.$on('send-list-select', this.onSendListSelect);
      // eventBus.$on('send-list-items-updated', this.onSendListItemsUpdated);
    },

    beforeDestroy() {
      eventBus.$off('send-list-select', this.onSendListSelect);
      // eventBus.$off('send-list-items-updated', this.onSendListItemsUpdated);
    },
  }
</script>

